import { FC } from 'react';

import { ChevronDown } from 'lucide-react';

import { cn } from '../../../utils';

export type FaqGroup = {
    id: string;
    label: string;
    questions: {
        question: string;
        answer: string;
    }[];
};

type Props = {
    group: FaqGroup;
    compact?: boolean;
};

export const FaqQuestionGroup: FC<Props> = ({ group, compact = false }) => (
    <section aria-labelledby={`${group.id}-questions-title`}>
        {!compact && (
            <div className="mb-5">
                <h2
                    id={`${group.id}-questions-title`}
                    className="text-xl font-bold"
                >
                    Часті запитання — {group.label.toLowerCase()}
                </h2>
                <p className="mt-1 text-sm text-muted-foreground">
                    Натисніть на запитання, щоб відкрити відповідь.
                </p>
            </div>
        )}

        <div
            className={cn(
                'divide-y overflow-hidden rounded-2xl border bg-card',
                compact && 'bg-background',
            )}
        >
            {group.questions.map(({ question, answer }) => (
                <details key={question} className="group">
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 font-medium transition-colors hover:bg-muted/50 focus-visible:bg-muted/50 focus-visible:outline-none sm:px-6">
                        <span>{question}</span>
                        <ChevronDown className="h-5 w-5 shrink-0 text-muted-foreground transition-transform group-open:rotate-180" />
                    </summary>
                    <p className="px-5 pb-5 text-sm leading-relaxed text-muted-foreground sm:px-6 sm:text-base">
                        {answer}
                    </p>
                </details>
            ))}
        </div>
    </section>
);
